module.exports.getScoreToShare = function(guesses, finalScoreStats, puzzleNumber, gameResult, undoHistory, highContrastEnabled, hintUsed) {
    let shareableScore = `Don't Wordle ${puzzleNumber}`
    let gameResultsTeaser = gameResult === 'WORDLE' ?
      ` - WORDLED\nI must admit that I Wordled!` : gameResult === 'ELIMINATED' ?
      ` - ELIMINATED\nWell technically I didn't Wordle!` : gameResult === 'SURVIVED' && hintUsed ?
      ` - SURVIVED\nHooray! I didn't Wordle today! I did use a hint, but don't judge me!` : gameResult === 'SURVIVED' ?
      ` - SURVIVED\nHooray! I didn't Wordle today! I didn't even use a hint!` : gameResult === 'SURRENDER' ?
      ` - SURRENDERED\nI gave up and surrendered!` : '';

    const hitSquare = highContrastEnabled ? '🟧' : '🟩';
    const partialSquare = highContrastEnabled ? '🟦' : '🟨';

    shareableScore += gameResultsTeaser;
    for(var i = 0; i < guesses.length; i++) {
      shareableScore += '\n';
      const guess = guesses[i];
      const guessResults = guess.wordResults.length === 0 ? ['ELIMINATED', 'ELIMINATED', 'ELIMINATED', 'ELIMINATED', 'ELIMINATED'] : guess.wordResults;
      for(var j = 0; j < guessResults.length; j++) {
        const letterResult = guessResults[j];
        if(letterResult === 'HIT') {
          shareableScore += hitSquare;
        } else if (letterResult === 'PARTIAL') {
          shareableScore += partialSquare;
        } else if (letterResult === 'MISS') {
          shareableScore += '⬜'
        } else if (letterResult === 'ELIMINATED') {
          shareableScore += '⬛'
        }
      }
      const wordsRemaining = guess.numberOfValidWordsRemaining;
      //could be 0
      if(wordsRemaining || wordsRemaining === 0) {
        shareableScore += wordsRemaining;
      }
    }
    const undosUsed = undoHistory.length;
    shareableScore += `\nUndos used: ${undosUsed}`;


    const userSurvived = gameResult === 'SURVIVED';
    if(userSurvived) {
      const { unusedLetterCount } = finalScoreStats;
      const finalRemainingWordCount = guesses[5].numberOfValidWordsRemaining;
      shareableScore += `\n\n  ${finalRemainingWordCount} words remaining`;
      shareableScore += `\nx ${unusedLetterCount} unused letters`;
      shareableScore += `\n= ${finalRemainingWordCount * unusedLetterCount} total score`;
    }

    shareableScore += `\n\nhttps://dontwordle.com`;

    return shareableScore;
}

module.exports.copyScoreToClipBoard = function(score) {
  return new Promise(function(resolve) {
    var el = document.createElement('textarea');
    el.value = score;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.left = '0';
    el.style.top = '0';
    el.style.width = '2px';
    el.style.height = '2px';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    document.body.appendChild(el);

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      el.contentEditable = true;
      el.readOnly = true;
      el.focus();
      var range = document.createRange();
      range.selectNodeContents(el);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);
    } else {
      el.select();
    }

    document.execCommand('copy');
    document.body.removeChild(el);
    resolve();
  });
};






